import { EnvConstant } from 'src/configs/env.configs';
import { GoogleRecaptchaExecuteError } from 'src/errors';

export class GoogleRecaptchaService {
  execute(action: 'register'): Promise<string> {
    return new Promise((resolve, reject) => {
      window.grecaptcha
        .execute(EnvConstant.GOOGLE_RECAPTCHA_SITE_KEY, { action })
        .then((token: string) => {
          resolve(token);
        })
        .catch((error: any) => {
          reject(new GoogleRecaptchaExecuteError(error?.message));
        });
    });
  }
}

const googleRecaptchaService = new GoogleRecaptchaService();

export const getGoogleRecaptchaService = () => {
  return googleRecaptchaService;
};
